// extracted by mini-css-extract-plugin
export var burgerIcon = "Header-module--burgerIcon--8f598";
export var footerContactText = "Header-module--footerContactText--2e70e";
export var headerTop = "Header-module--headerTop--01e15";
export var icon = "Header-module--icon--834d7";
export var iconSocial = "Header-module--iconSocial--4a73e";
export var iconSocialX = "Header-module--iconSocialX--3998a";
export var listMenu = "Header-module--listMenu--315ab";
export var listMenuContainer = "Header-module--listMenuContainer--ec4c7";
export var menuIcons = "Header-module--menuIcons--c0fc1";
export var mobileMenu = "Header-module--mobileMenu--52d0f";
export var mobileMenuOpen = "Header-module--mobileMenuOpen--12c71";
export var navContainer = "Header-module--navContainer--f5a09";
export var pHeaderBigger = "Header-module--pHeaderBigger--dbc34";
export var searchButton = "Header-module--searchButton--30f26";
export var searchForm = "Header-module--searchForm--64245";
export var searchInput = "Header-module--searchInput--a2e89";
export var subMenu = "Header-module--subMenu--5e0d8";
export var subMenuLink = "Header-module--subMenuLink--d54a4";
export var swiperButtonNav = "Header-module--swiperButtonNav--75358";
export var swiperButtonNext = "Header-module--swiperButtonNext--ec4d0";
export var swiperButtonPrev = "Header-module--swiperButtonPrev--32583";
export var topMenuList = "Header-module--topMenuList--65c0a";
export var upcomingSlideHeadMobile = "Header-module--upcomingSlideHeadMobile--9337f";
export var widthUpcoming = "Header-module--widthUpcoming--2f658";